/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Team_Summary_Memory_NoneInputs */



/**
* | output |
* | --- |
* | "Prepare the next one with Wundo and the thread builds up as you go." |
*
* @param {Team_Summary_Memory_NoneInputs} inputs
* @param {{ locale?: "en" | "nl" | "fr" }} options
* @returns {LocalizedString}
*/
export const team_summary_memory_none = /** @type {((inputs?: Team_Summary_Memory_NoneInputs, options?: { locale?: "en" | "nl" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Team_Summary_Memory_NoneInputs, { locale?: "en" | "nl" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return /** @type {LocalizedString} */ ("Bereid je volgende voor met Wundo, dan bouw je stap voor stap de rode draad op.")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Préparez le prochain avec Wundo, et le fil de vos échanges se construit au fur et à mesure.")
	return /** @type {LocalizedString} */ ("Prepare the next one with Wundo and the thread builds up as you go.")
});